import type { JSX } from 'react';

import { Flex } from '@change-corgi/design-system-legacy/layout';

import type { User } from 'src/app/pages/movement/shared/types';
import { useCurrentUser, useLoginState } from 'src/app/shared/hooks/session';

import { StatusBox } from './StatusBox';

type StatusBoxContainerProp = {
	isVictory: boolean;
	owner: User;
	publishedAt: string;
	weeklySignatureCount: number;
	onDelete: () => void;
};

export function StatusBoxContainer({
	isVictory,
	owner,
	publishedAt,
	weeklySignatureCount,
	onDelete,
}: StatusBoxContainerProp): JSX.Element {
	const currentUser = useCurrentUser();
	const currentUserId = currentUser?.id;
	const isPetitionOwner = currentUserId && currentUserId === owner.id;
	const isAdmin = !!currentUser?.roles.staff;
	const userIsAuthenticated = useLoginState() === 'AUTHENTICATED';

	return (
		<Flex sx={{ height: 40, alignItems: 'center' }} px={8}>
			<StatusBox
				isAdmin={isAdmin}
				isVictory={isVictory}
				userIsAuthenticated={userIsAuthenticated}
				onDelete={onDelete}
				isPetitionOwner={isPetitionOwner}
				weeklySignatureCount={weeklySignatureCount}
				publishedAt={publishedAt}
			/>
		</Flex>
	);
}
